/**
 * PageLoader — the standard, brand-consistent page-load state.
 *
 * One reusable loader so every fetching page (insights, resources, campaign
 * landings, etc.) shows the same on-brand spinner instead of ad-hoc "Loading…"
 * text. Pass `label` to customise the caption.
 */
import React from "react";
import { Loader2 } from "lucide-react";

const PageLoader = ({ label = "Loading…", testid = "page-loader", className = "" }) => (
  <div
    className={`ek-container py-32 flex flex-col items-center justify-center text-center ${className}`}
    role="status"
    aria-live="polite"
    data-testid={testid}
  >
    <Loader2 className="animate-spin text-[#7737F6]" size={28} aria-hidden="true" />
    <p className="text-zinc-500 text-sm mt-4 tracking-[0.04em]">{label}</p>
  </div>
);

export default PageLoader;
